import { useNavigate } from 'react-router-dom';
import { showToast } from '../../components/Toast/Toast';
import { ToastOptions } from '../../components/Toast/Toast.types';

const useNavigateWithToast = () => {
  const navigate = useNavigate();
  return (to: string, toastOptions: ToastOptions) => {
    navigate(to);
    showToast(toastOptions);
  };
};

export default useNavigateWithToast;
